import { REGISTRATION_STATES } from '@repo/api-kit/queries/registration-states';
import { ROUTE_PARAMS } from '../route-params';

export const FR_GLOBAL_MAPPING = {
  [REGISTRATION_STATES.COMPANY_TENURE]: {
    url: '/screening/:organization_id/company-tenure',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.LEGAL_FORM_GROUP]: {
    url: '/screening/:organization_id/legal-form-group',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
};
